import { render } from "./JobRunsList.vue?vue&type=template&id=4db24584"
import script from "./JobRunsList.vue?vue&type=script&lang=js"
export * from "./JobRunsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__